<template>
    <div class="messageList">
        <div class="ym_header bg2" style="height: 280px;">
            <div style="height: 200px;width: 1200px;margin: 0 auto;display: flex;align-items: center">
                <div style="height: 149px;width: 500px;float: left;">
                    <router-link to="/">
                        <img class="ym_logo_img" src="/static/img/logo.png" alt="">
                    </router-link>
                    <p class="ym_logo_title">双鸭山仲裁委员会</p>
                </div>
            </div>
            <div class="tite_a">
                <div class="tite_b">
                    <router-link to="/"><i></i>网站首页</router-link>
                    <router-link to="/about"><i class=""></i>关于我们</router-link>
                    <router-link to="/serveList"><i class=""></i>仲裁服务</router-link>
                    <router-link to="/dynamiList"><i class=""></i>双仲动态</router-link>
                    <router-link to="/messageList"><i class=""></i>通知公告</router-link>
                </div>
            </div>
        </div>

        <div class="ym_xiang" style="margin-top:15px;">
            <div class="ym_list_layout2">
                <div class="ym_main_box" style="border: 1px solid #ebebeb;display: flex;">
                    <div class="ym_main_box_n">
                        <div>
                            <ul>
                                <li class="dropdown-bt ym_main_box_li">
                                    <div class="yiji">通知公告</div>
                                </li>
                                <div v-for="(menuItem, index) in subMenus" :key="index">
                                    <li style="margin-top: 10px;"></li>
                                    <a href="javascript:;" class="dropdown-btn" :class="{ active: menuItem.active }"
                                        @click="toggleDropdown(index)">
                                        <li class="butt boxx" style="position: relative;">
                                            <div class="bhjj_vo">{{ menuItem.name }}<i
                                                    :class="['layui-icon', menuItem.active ? 'layui-icon-up' : 'layui-icon-down', 'layui-nav-more', 'layui_i']"
                                                    style="left: 185px;"></i></div>
                                        </li>
                                    </a>
                                    <li class="dropdown-container dropdown_li" :class="{ judge: menuItem.active }"
                                        :style="{ display: 'block', height: menuItem.active ? '50px' : '0px', padding: menuItem.active ? '10px' : '0px', transition: '0.5s', overflow: menuItem.active ? '' : 'hidden' }">
                                        <router-link class="sjsj" style="color: #333;"
                                            :to="`/messageList?type=${menuItem.code}`">
                                            <div class="s_div left_btns s_div_btn"
                                                :class="{ left_btns_on: menuItem.active }" style="border: none;">{{
                                                menuItem.name }}
                                            </div>
                                        </router-link>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <div style="width: 963px;height: 100%;float: right;">
                        <div class="s_div_xtitle">
                            <span>所在位置：<router-link class="sy_title" to="/">首页</router-link></span><span>/ {{
                                currentTitle
                                }}</span>
                        </div>
                        <div style="margin: 0 auto 32px;"></div>
                        <div style="height: 70%;" id="ym_list_RightCnt">
                            <div class="ym_map_div">
                                <div v-for="article in articles" :key="article.id">
                                    <a class="bianse" @click="getArticleLink(article)">
                                        <div style="height: 45px;align-items: center;display: flex;">
                                            <div
                                                style="width: 7px;height: 7px;border-radius: 40px;background-color: red;line-height: 45px;margin: 0 16px 0 46px;">
                                            </div>
                                            <div
                                                style="letter-spacing: 1px;font-size: 18px;width: 725px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                                {{ article.title }}
                                            </div>
                                            <div style="flex: 1 1 0%;"></div>
                                            <div class="ssc">[ {{ article.publishDate }} ]</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div id="demo1" class="ym_fenye"></div>
                    </div>
                </div>
            </div>
        </div>

        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { getApiUrl, API_CONFIG } from '@/api'

export default {
    name: 'MessageList',
    components: { Footer },
    data() {
        return {
            currentTitle: '通知公告',
            subMenus: [],
            articles: [],
            menuItem: {}
        }
    },
    watch: {
        '$route'() {
            this.updateCurrentType()
            this.loadArticles()
        }
    },
    mounted() {
        this.loadSubMenus()
        this.updateCurrentType()
        this.loadArticles()
    },
    methods: {
        async loadSubMenus() {
            try {
                const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_TYPE_LIST, '/TZGG'))
                const result = await response.json()
                if (result.code === 0 && result.data) {
                    this.subMenus = result.data.map(item => ({
                        name: item.typeName,
                        code: item.typeCode,
                        active: false
                    }))
                    this.updateCurrentType()
                }
            } catch (error) {
                console.error('加载子菜单失败:', error)
            }
        },
        async loadArticles() {
            const type = this.$route.query.type || (this.subMenus[0] && this.subMenus[0].code) || 'TZGG'
            try {
                const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_CONTENT_LIST, `/${type}?pageNum=1&pageSize=10`))
                const result = await response.json()
                if (result.code === 0 && result.data) {
                    this.articles = result.data
                }
            } catch (error) {
                console.error('加载文章失败:', error)
            }
        },
        updateCurrentType() {
            const type = this.$route.query.type
            if (type) {
                this.subMenus.forEach(item => {
                    item.active = item.code === type
                })
                const activeMenu = this.subMenus.find(item => item.active)
                this.currentTitle = activeMenu ? activeMenu.name : '通知公告'
            } else {
                // 默认展开第一个菜单
                if (this.subMenus.length > 0) {
                    this.subMenus[0].active = true
                    this.currentTitle = this.subMenus[0].name
                    this.loadArticles()
                }
            }
        },
        async getArticleLink(article) {
            if (article.contentType === 2) {
                const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_DETAIL, `/${article.id}`))
                const result = await response.json()
                window.open(result.data.content)
            } else {
                const targetRoute = this.$router.resolve({ name: 'Detail', query: { id: article.id } });
                window.open(targetRoute.href, '_blank');
            }
        },
        toggleDropdown(index) {
            this.subMenus.forEach((item, i) => {
                item.active = i === index ? !item.active : false
            })
            if (this.subMenus[index].active) {
                this.currentTitle = this.subMenus[index].name
                this.$router.push(`/messageList?type=${this.subMenus[index].code}`)
            }
        }
    }
}
</script>

<style scoped>
.ym_header {
    margin-top: 0;
    height: 150px;
    background-repeat: no-repeat;
    background-position: top center;
}

.ym_header .ym_search dl {
    height: 35px;
}

.ym_header .ym_search input {
    padding-left: 2px;
    width: 160px;
    border: 0;
    margin-left: 3px;
    background: #F00;
    text-indent: 10px;
    color: #0062c7;
    line-height: 33px;
    font-size: 16px;
    background: #c7dbef;
    outline: none;
}

.ym_header .ym_search dl dt input::placeholder {
    color: #0062c7;
}

/* 鍏叡渚ц竟鏍忔牱寮� */
.left_btns {
    height: 50px;
    color: #fff;
    line-height: 50px;
    width: 220px;
    margin: auto;
    color: #3e3e3e;
    text-align: center;
    letter-spacing: 2px;
    /*padding-left: 20px;*/
    border: 1px solid #ccc;
    background: #dbedfe;
    margin-top: 20px;
    border-radius: 4px;
}

.left_btns:hover {
    background-color: #a1dbff;
    cursor: pointer;
    border: 1px solid #245399;
}

.left_btns_on {
    color: #fff;
    /* background-image: linear-gradient(to right,#3f78dd,#66b6e8); */
    /* background: linear-gradient(0deg,#4e77fc,#3c6fef 51%,#4c6dff); */
    background: #125db2 !important;
    border: 1px solid #245399;
}

/* 鍏叡搴曢儴鏍峰紡 */
.ym_footer .ym_layout {
    width: 1300px;
}

.ym_header .ym_search button {
    /*margin-top: 1px;*/
    border: 0px;
    width: 80px;
    height: 35px;
    color: #fff;
    margin-left: 10px;
    line-height: 35px;
    font-size: 16px;
    cursor: pointer;
    background: #245399;
    border-radius: 20px;
}

.ym_header .ym_search button:hover {
    background: #0062c7;
}

.ym_slogan_text span {
    padding: 0 50px 0 50px;
}

.ym_xiang {
    margin-bottom: 15px;
}

@keyframes maskedAnimation {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: -100% 0;
    }
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.ym_header .ym_menu ul {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0;
    overflow: visible;
    z-index: 200;
}

.ym_header .ym_menu li {
    float: left;
    padding: 0 23px;
    width: 100px;
    height: 42px;
    text-align: center;
    overflow: hidden;
}

.ym_header .ym_menu ul li:nth-child(4) {
    margin-right: 120px;
}

.ym_header .ym_menu li:first-child {
    padding: 0 20px;
}

.ym_header .ym_menu ul li:nth-child(4) {
    margin-right: 120px;
}

.ym_header .ym_menu ul li:nth-child(5) {
    padding-left: 33px;
}

.ym_header .ym_menu ul li:nth-child(6) {
    padding-left: 13px;
}

.ym_header .ym_menu li a {
    height: 42px;
    color: #FFF;
    line-height: 42px;
    font-size: 16px;
    background: rgba(255, 255, 255, 0.7);
    display: block;
}

.ym_header .ym_menu li a:nth-child(2) {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.ym_header .ym_menu li a:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.ym_header .ym_menu li a:hover {
    color: #245399 !important;
    background: rgba(255, 255, 255, 1);
}

.ym_header .ym_menu li a.m {
    height: 50px;
    line-height: 42px;
    font-size: 18px;
    background: bottom center no-repeat;
}

.ym_header .ym_menu li:hover a.m {
    color: #245399 !important;
}

.ym_list_layout2 {
    margin: 0 auto;
    width: 1200px;
    overflow: hidden;
    background: #fff;
    /* box-shadow: 0px 3px 8px 1px rgb(176 176 176 / 75%); */
}

.ym_biaoti span {
    font-size: 16px;
    font-weight: 500;
    margin-left: 20px;
    line-height: 50px;
}

.ym_biaoti span a:hover {
    color: rgb(15, 88, 205);
}

.ym_list_LeftsCnt ul {
    padding: 0;
    overflow: hidden;
}

.ym_list_LeftsCnt ul li {
    margin-bottom: 1px;
    height: auto;
    list-style: none;
    overflow: hidden;
}

.ym_list_LeftsCnt ul li a {
    color: #FFF;
    line-height: 55px;
    font-size: 18px;
    text-align: center;
    background: #245399;
    cursor: pointer;
    display: block;
}

.ym_list_LeftsCnt ul li.cur a {
    background: #245399;
}

.ym_list_LeftsCnt ul li:hover a {
    background: #0e77b4;
}

.ym_map_RightCnt .title p {
    color: #999999;
}

.ym_map_RightCnt h1 {
    text-align: center;
    font-size: 25px;
    color: #333;
    font-weight: bold;
    padding: 10px;
}

.ym_map_div {
    padding: 20px;
    min-height: 400px;
    /* text-align: center; */

}

.ym_footer p {
    color: #8fddec;
    font-size: 14px;
    line-height: 25px;
}

.ym_footer_des img {
    min-width: auto;
    min-height: auto;
}


.ym_footer p a {
    color: #8fddec;
}

.ym_footlist ul li {
    width: 100%;
    height: 38px;
    float: left;
    text-align: center;
}

.ym_footlist ul li a {
    font-size: 14px;
    /* color: #c2eeff; */
    color: rgba(255, 255, 255, .5);
    line-height: 38px;
    display: block;
}

.ym_footnav p {
    line-height: 38px;
    /* color: #c2eeff; */
    color: rgba(255, 255, 255, .5);
}

.ym_footnav p span {
    margin-right: 20px;
}

.ym_ewm img {
    width: 80px;
}

.ym_foot_bot p {
    color: #c2eeff;
}

.ym_map_left>h3:first-child {
    margin: 0;
}

.ym_map_left h3 {
    margin: 46px 0 6px 0;
}

.ym_map_right img {
    min-width: 0;
    width: 200px;
    height: 200px;
    margin-left: 50px;
}

.ym_map_right h3 {
    text-align: center;
    margin-top: 30px;
    margin-left: 45px;
}

.ym_map_right h2 {
    text-align: center;
    margin-top: 30px;
    margin-left: 45px;

}

.ym_map_div b {
    width: 200px;
    display: inline-block;
    height: 60px;
    padding: 0 40px;
    font-size: 20px;
    /*margin-right: 100px;*/
    line-height: 60px;
    /* text-align: left; */
    /* background-color: rgba(40, 132, 218, 0.8); */
    margin-bottom: 10px;
}

.ym_zcfy_RightCnt h2 {
    text-align: center;
    padding-left: 100px;
    width: 1100px;
    font-size: 22px;
    font-weight: 600;
    margin: 0px 0 15px 0;
}

.ym_zcfy_RightCnt p {
    text-align: center;
    /*color: rgb(114, 112, 112);*/
}

.ym_zcfy_RightCnt p span {
    margin: 0 20px;
}


.ym_xqy_div p {
    text-align: justify;
    line-height: 2em;
}

.ym_xqy_dy span:hover {
    color: rgb(230, 30, 30);
}

.ym_xqy_dy .ym_dy {
    margin-right: 30px;
    /* 鏀� */
}

.ym_xqy_dy .ym_dy img {
    min-width: auto;
    min-height: auto;
    width: 15px;
}

.ym_xqy_dy .ym_gb img {
    min-width: auto;
    min-height: auto;
    width: 15px;
}

.ym_xqy_btn_left .ym_gb a:hover {
    color: rgb(253, 0, 0);

}

.ym_xqy_btn_left i {
    color: rgba(93, 91, 91, 0.5);
    margin-right: 15px;
}

.ym_xqy_btn_right i {
    color: rgba(93, 91, 91, 0.5);
    margin-left: 15px;
}

.ym_xqy_btn .ym_xqy_btn_left a:hover {
    color: #245399;
}

.ym_xqy_btn .ym_xqy_btn_right a:hover {
    color: #245399;
}

.ym_fy_RightCnt h1 {
    text-align: center;
    color: #000;
    margin-left: 0;
    width: 1000px;
}


.ym_zcfy_div_left span {
    font-size: 20px;
}

.ym_zcfy_div_left h2 {
    margin-top: 50px;
    line-height: 40px;

}

.ym_zcfy_div_left h2 button {
    float: right;
}

.ym_zcfy_div_left h2 span p {
    color: rgb(201, 54, 54);
}

.ym_list_list ol,
.ym_list_list li {
    display: table-cell;
    vertical-align: middle;
    font-size: 18px;
}

.ym_list_list ol {
    width: 50px;
    /* background: #2692d1; */
    text-align: center;
    color: #FFF;
    /* padding: 15px 10px; (鏀�)*/
}

.ym_list_list ol i {
    font-size: 26px;
    color: #666;
}

.ym_list_list li {
    padding: 10px 10px 5px 5px;
}


.ym_list_list li .ym_span_center i {
    font-size: 30px;
    font-weight: 700;
    color: rgb(10, 86, 152);
}

.ym_list_list li .ym_span_center a:active i {
    color: rgb(255, 0, 0);
}

.ym_list_list li p a {
    display: inline-block;
    color: blue;
    padding-left: 5px;
}

.ym_list_RightCnt ul,
ol {
    list-style: none;
}

.ym_list_RightCnt .ym_list_time li dt em {
    font-size: 16px;
    line-height: 20px;
    display: block;
}

.ym_list_RightCnt .ym_list_time li dd {
    width: calc(100% - 110px);
    float: right;
}

.ym_list_RightCnt .ym_list_time li dd h3 {
    font-weight: bold;
    margin-bottom: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ym_list_RightCnt .ym_list_time li dd .notice_p {
    line-height: 1.5em;
    height: 44px;
    overflow: hidden;
    font-size: 16px;
    text-align: justify;
}

.layui-laypage .layui-laypage-curr .layui-laypage-em {
    background-color: #125db2;
}


.ym_list_time ol,
.ym_list_time li {
    display: table-cell;
    vertical-align: middle;
    font-size: 12px;
}

.ym_list_time ol {
    width: 85px;
    background: #4683df;
    text-align: center;
    color: #FFF;
    /* padding: 15px 0; */
}

.ym_list_time ol dl dt {
    font-size: 34px;
    line-height: 40px;
    display: block;
    margin-top: 3px;
}

.ym_list_time ol dl dd {
    font-size: 18px;
    line-height: 30px;
    display: block;
    font-weight: 700;
}

.ym_list_time li {
    padding: 5px 10px 10px 15px;
    width: 890px;
    /* margin: 5px 10px 10px 15px; */
    /* width: 900px!important; */
}

.ym_list_time li:hover {
    background: #dbedfe;
}

.ym_list_time li h3 a {
    display: block;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    overflow: hidden;
    font-weight: bold;
}

.ym_list_time li div p {
    line-height: 18px;
    font-size: 14px;
    color: rgb(23, 23, 23);
    overflow: hidden;
    max-height: 40px;
    /* width: 920px; */
}

.ym_list_time li p a {
    display: inline-block;
    /* color: blue; */
}


.lianghang p {
    font-size: 12px;
}

.ym_list_sousuo li {
    padding-top: 5px;
    /* background-color: aquamarine; */
}

.ym_list_sousuo li .ym_span_left b {
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: black;
    border-radius: 50px;
    margin-bottom: 22.5px;
    margin: 0 20px;
}

.ym_list_sousuo li .ym_span_left {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    line-height: 52px;
    width: 650px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

}

.ym_list_sousuo li .ym_span_right {
    float: right;
    line-height: 52px;
    margin-right: 20px;
    font-size: 14px;
    color: rgb(63, 62, 62);
}

.ym_main_box {
    /* height: 700px; */
    float: left;
    border-radius: 4px;
}

.ym_main_box_n {
    width: 235px;
    /* height: 100%; */
    float: left;
    box-shadow: 15px -8px 44px 1px rgb(133 133 133/19%);
}

.ym_main_box_li {
    height: 60px;
    padding: 10px;
    font-size: 26px;
    border-bottom: 1px solid #ebebeb;
}

.butt {
    height: 45px;
    padding: 10px;
    font-size: 21px;
}

.dropdown_li {
    height: 0px;
    padding: 0px;
    font-size: 21px;
    /* display: none; */
    overflow: hidden;
    background-color: #f2f7ff;
    box-shadow: 0 17px 10px -8px #e3e7ee inset;
    color: #333333;
}

.s_div_btn {
    width: 148px;
    text-align: center;
    line-height: 29px;
    margin: auto;
    border-radius: 15px;
    border: none;
    /* background: linear-gradient(0deg,#4e77fc,#125db2 51%,#125db2); */
    background-color: #f2f7ff;
    height: 29px;
    margin-top: 11px;
    font-size: 18px;
}

.s_div_xtitle {
    height: 40px;
    border-bottom: 1px solid #ebebeb;
    padding-top: 40px;
    padding-left: 40px;
    font-size: 18px;
    color: #333;
}

.ssc {
    color: #878787;
    margin-right: 40px;
    font-size: 18px;
    white-space: nowrap;
}

.sy_title:hover {
    color: #125db2;
}

.bg2 {
    background-color: #4d92df;
    background-repeat: no-repeat;
    background-position: top center;
}

.tite_a a {
    display: inline-block;
    font-size: 20px;
    color: #fff;
    line-height: 79px;
    /*padding: 0 44px;*/
    padding: 0 76px;
    letter-spacing: 2px;
    float: left;
    font-weight: 600;
    height: 79px;
}

.tite_a a:hover {
    background-color: #2a6eba;

}

a li:hover {
    color: black;
    background-color: #ecf5ff;
}

.s_title:hover {
    background-color: #ecf5ff;
}

.bianse:hover {
    color: #125db2 !important;
}

.bianse {
    color: #4a4a4a;
    cursor: pointer;
}

.s_div:hover {
    background-color: #ecf5ff;
}

@keyframes rotate {
    0% {
        transform: rotateZ(0deg);
        /*浠�0搴﹀紑濮�*/
    }

    100% {
        transform: rotateZ(360deg);
        /*360搴︾粨鏉�*/
    }
}

.layui_i {
    display: block;
    position: absolute;
    top: 9px;
    left: 190px;
    transition: all 0.5s ease;
    font-size: 24px;
}

.yiji {
    text-align: center;
    line-height: 60px;
    color: #333;
}

.bhjj_vo {
    text-align: center;
    line-height: 50px;
    color: #333;
    font-size: 22px;
}

.ym_logo_img {
    width: 80px;
    margin: 42px 20px 0 0;
    float: left;
}

.ym_logo_title {
    font-size: 42px;
    margin: 43px 20px 0 0;
    color: #fff;
    font-weight: 600;
}

.tite_a {
    height: 79px;
    background-color: #125db2;
}

.tite_b {
    width: 1200px;
    height: 74px;
    margin: 0 auto;
}

.tite_a a {
    display: inline-block;
    font-size: 20px;
    color: #fff;
    line-height: 79px;
    padding: 0 76px;
    letter-spacing: 2px;
    float: left;
    font-weight: 600;
    height: 79px;
    text-decoration: none;
}

.tite_a a:hover {
    background-color: #2a6eba;
}

.ym_logo_img {
    width: 80px;
    margin: 42px 20px 0 0;
    float: left;
}

.ym_logo_title {
    font-size: 42px;
    margin: 43px 20px 0 0;
    color: #fff;
    font-weight: 600;
}

.ym_main_box {
    float: left;
    border-radius: 4px;
}

.ym_main_box_n {
    width: 235px;
    float: left;
    box-shadow: 15px -8px 44px 1px rgb(133 133 133/19%);
}

.ym_main_box_li {
    height: 60px;
    padding: 10px;
    font-size: 26px;
    border-bottom: 1px solid #ebebeb;
}

.yiji {
    text-align: center;
    line-height: 60px;
    color: #333;
}

.butt {
    height: 45px;
    padding: 10px;
    font-size: 21px;
}

.bhjj_vo {
    text-align: center;
    line-height: 50px;
    color: #333;
    font-size: 22px;
}

.dropdown_li {
    height: 0px;
    padding: 0px;
    font-size: 21px;
    overflow: hidden;
    background-color: #f2f7ff;
    box-shadow: 0 17px 10px -8px #e3e7ee inset;
    color: #333333;
}

.s_div_btn {
    width: 148px;
    text-align: center;
    line-height: 29px;
    margin: auto;
    border-radius: 15px;
    border: none;
    background-color: #f2f7ff;
    height: 29px;
    margin-top: 11px;
    font-size: 18px;
}

.left_btns_on {
    color: #fff;
    background: #125db2 !important;
    border: 1px solid #245399;
}

.s_div_xtitle {
    height: 40px;
    border-bottom: 1px solid #ebebeb;
    padding-top: 40px;
    padding-left: 40px;
    font-size: 18px;
    color: #333;
}

.sy_title:hover {
    color: #125db2;
}

.bianse {
    color: #4a4a4a;
    text-decoration: none;
}

.bianse:hover {
    color: #125db2 !important;
}

.ssc {
    color: #878787;
    margin-right: 40px;
    font-size: 18px;
    white-space: nowrap;
}
</style>